module.exports = __webpack_public_path__ + "img/UM.98dee20e.png";